module.exports = __webpack_public_path__ + "static/img/qnstatus3.ac70c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus3.png
// module id = 365
// module chunks = 0